/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-return-awaitya */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-await */
/* eslint-disable no-throw-literal */
import RetailerOffer from './RetailerOffer';
import { getEnvironment } from '@andromeda/util-environment';
import Option from './option';
import {
	GetOffersResponse,
	GetLocationsResponse,
	GetLocationsResponseKr,
	GetLocationsResponseTgt,
	GetProductsResponse,
	GetLocationsResponseSingleMRC,
} from './response';
import { Chains } from './kroger/chains';
import { MercuryStore, MercuryStoreKr, MercuryStoreTgt } from './location';

export enum MercuryRetailer {
	WALMART = 'wmt',
	KROGER = 'kro',
	AMAZON = 'amzn',
	TARGET = 'tgt',
	DRIZLY = 'drz',
	RESERVE = 'res',
	INSTACART = 'instacart',
	WHOLEFOODS = 'wholefoods'
}

export const integratedRetailerMap: { [key: string]: MercuryRetailer } = {
	walmart: MercuryRetailer.WALMART,
	kroger: MercuryRetailer.KROGER,
	target: MercuryRetailer.TARGET,
};

export const isWalmartLocation = (
	location: MercuryStore | MercuryStoreKr | MercuryStoreTgt
): location is MercuryStore =>
	(location as MercuryStore).fulfillmentStoreId !== undefined;

export const isKrogerLocation = (
	location: MercuryStore | MercuryStoreKr | MercuryStoreTgt
): location is MercuryStoreKr =>
	(location as MercuryStoreKr).address.line1 !== undefined;

export const isTargetLocation = (
	location: MercuryStore | MercuryStoreKr | MercuryStoreTgt
): location is MercuryStoreTgt =>
	(location as MercuryStoreTgt).address.line !== undefined;

const apiUrl = 'https://products.polaris.me/v1/integrations'
const fetchJson = async (url: string, payload: any): Promise<Object> => {
	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	};
	const fetchOpts = {
		method: 'POST',
		headers,
		body: JSON.stringify(payload),
	};
	const response = await fetch(url, fetchOpts);
	// eslint-disable-next-line no-return-awaitya
	return await response.json();
};

const fetchJsonGet = async (url: string): Promise<Object> => {
	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	};
	const fetchOpts = {
		method: 'GET',
		headers,
	};
	const response = await fetch(url, fetchOpts);
	// eslint-disable-next-line no-return-awaitya
	return await response.json();
};

// eslint-disable-next-line consistent-return
const fetchRetry = async (
	url: string,
	payload: any,
	retries = 2
): Promise<Object> => {
	try {
		const headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		};
		const fetchOpts = {
			method: 'POST',
			headers,
			body: JSON.stringify(payload),
		};
		const response = await fetch(url, fetchOpts);
		return await response.json();
	} catch (error) {
		console.error(error);
		if (retries > 0) {
			// eslint-disable-next-line no-return-await
			return await fetchRetry(url, payload, retries - 1);
		}
		throw error as Error;
	}
};

export const getOffers = async (
	ingredientIds: number[],
	retailer: MercuryRetailer,
	locationId: string,
	isBundle: boolean,
	limit: number = 5,
	includeDefault: boolean = false,
	host: string = 'https://live.polaris.me'
): Promise<Option<GetOffersResponse>> => {
	const endpoint = isBundle
		? `${apiUrl}/${retailer}/bundle/offers`
		: retailer === 'kro'
			? `${host}/api/products/v1/integrations/kro/offers`
			: `${host}/api/products/v1/integrations/${retailer}/offers`;
	const payload = {
		ingredientIds,
		limit,
		locationId,
		includeDefault,
	};
	const payloadBundle = {
		ingredientIds,
		limit,
	};
	try {
		const data = isBundle
			? ((await fetchRetry(endpoint, payloadBundle)) as GetOffersResponse)
			: ((await fetchRetry(endpoint, payload)) as GetOffersResponse);
		return { some: data, none: false, reason: '' };
	} catch (ex) {
		console.error(ex);
		return {
			some: null,
			none: true,
			reason: 'getOffers exception thrown. See console for error.',
		};
	}
};

/**
 * Gets products from Walmart without pricing information
 * @param ingredientIds list of item Ids used to get products
 * @param limit number of products to return for each ingredientId
 */
export const getProducts = async (
	ingredientIds: number[],
	limit: number = 5
): Promise<Option<GetProductsResponse>> => {
	const endpoint = `${apiUrl}/wmt/products`;
	const payload = {
		ingredientIds,
		limit,
	};
	try {
		const data = (await fetchJson(
			endpoint,
			payload
		)) as GetProductsResponse;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getProducts threw an exception. see console for error',
		};
	}
};

export const getDefaultOffers = async (
	promotionId: string
): Promise<Option<GetOffersResponse>> => {
	try {
		const endpoint = `https://cdn.polaris.me/cva/shopping-list/c/defaults/${promotionId}.json`;
		const response = await fetch(endpoint);
		const data = (await response.json()) as GetOffersResponse;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getDefaultOffers threw an exception. see console for error',
		};
	}
};

export const getDefaultOffersSc = async (
	ingredientIds: number[],
	retailer: string,
	limit: number = 1
): Promise<Option<GetProductsResponse>> => {
	try {
		const endpoint = `https://products.polaris.me/v1/integrations/${retailer}/products`;
		const payload = {
			ingredientIds,
			limit,
		};
		const data = (await fetchJson(
			endpoint,
			payload
		)) as GetProductsResponse;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getDefaultOffersSc threw an expection. See console for error',
		};
	}
};

export const getLocationsKr = async (
	zip: string,
	limit: number = 20,
	host: string = 'https://live.polaris.me'
): Promise<Option<GetLocationsResponseKr>> => {
	const endpoint =
		zip && zip.length > 0
			? `${host}/api/products/v1/integrations/kro/locations?zip=${zip}`
			: `${host}/api/products/v1/integrations/kro/locations`;
	const payload = {
		limit,
	};
	try {
		const data = (await fetchJson(
			endpoint,
			payload
		)) as GetLocationsResponseKr;
		/* eslint no-param-reassign: "error" */
		data.locations.forEach((l) => {
			const chain = Chains.get(l.chain);
			if (chain) {
				l.chain = chain.Name;
				l.logo = chain.ImageUrl;
				l.url = chain.Url;
				l.preformatted = chain.Preformatted;
			}
		});
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getLocationsKr threw an exception. See console for error',
		};
	}
};

export const getLocationsTgt = async (
	zip: string,
	limit: number = 20,
	host: string = 'https://live.polaris.me'
): Promise<Option<GetLocationsResponseTgt>> => {
	const endpoint =
		zip && zip.length > 0
			? `${host}/api/products/v1/integrations/tgt/locations?zip=${zip}`
			: `${host}/api/products/v1/integrations/tgt/locations`;
	const payload = {
		limit,
	};
	try {
		const data = (await fetchJson(
			endpoint,
			payload
		)) as GetLocationsResponseTgt;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getLocationsTgt threw an exception. See console for error ',
		};
	}
};

export const getLocations = async (
	retailer: MercuryRetailer,
	zip: string = '',
	limit: number = 20,
	host: string = 'https://live.polaris.me'
): Promise<
	Option<
		GetLocationsResponse | GetLocationsResponseKr | GetLocationsResponseTgt
	>
> => {
	// ensure Zip is a string
	zip = zip.toString();
	if (retailer === MercuryRetailer.KROGER) {
		return getLocationsKr(zip, limit, host);
	}
	if (retailer === MercuryRetailer.TARGET) {
		return getLocationsTgt(zip, limit, host);
	}
	const endpoint =
		zip && zip.length > 0
			? `${host}/api/products/v1/integrations/wmt/locations?zip=${zip}`
			: `${host}/api/products/v1/integrations/wmt/locations`;
	console.log(`Checkout Zip ${zip}`);
	const payload = {
		limit,
	};
	try {
		const data = (await fetchJson(
			endpoint,
			payload
		)) as GetLocationsResponse;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getLocations threw an exception. See console for error',
		};
	}
};

export const getSingleMRCLocations = async (
	zip: string = ''
): Promise<Option<GetLocationsResponseSingleMRC>> => {
	// ensure Zip is a string
	zip = zip.toString();
	const endpoint =
		zip && zip.length > 0
			? `https://shopper-gam.polaris.me/v1/sdu/1851/retailer-locations.json?zipCode=${zip}`
			: `https://shopper-gam.polaris.me/v1/sdu/1851/retailer-locations.json`;
	console.log(`Checkout Zip ${zip}`);
	try {
		const data = (await fetchJsonGet(
			endpoint
		)) as GetLocationsResponseSingleMRC;
		return { some: data, none: false, reason: '' };
	} catch (err) {
		console.error(err);
		return {
			some: null,
			none: true,
			reason: 'getLocations threw an exception. See console for error',
		};
	}
};

const getQueryStringParamValue = (key: string): string => {
	const url = new URL(window.location.href);
	return url.searchParams.get(key) || '';
};

// eslint-disable-next-line max-len
export const fetchRetailerOffers = async (
	itemIds: number[],
	fulfillmentStoreId: string,
	isBundle: boolean,
	maxOffers: number = 5,
	retailerName = MercuryRetailer.WALMART,
	includeDefault: boolean = false
): Promise<RetailerOffer[] | undefined> => {
	const limitp = getQueryStringParamValue('limit');
	const limit = parseInt(limitp, 10) || maxOffers;
	// eslint-disable-next-line no-restricted-globals
	const offerResult: Option<GetOffersResponse> = isNaN(limit)
		? // eslint-disable-next-line max-len
		  await getOffers(
				itemIds,
				retailerName,
				fulfillmentStoreId,
				isBundle,
				limit,
				includeDefault
		  )
		: // eslint-disable-next-line max-len
		  await getOffers(
				itemIds,
				retailerName,
				fulfillmentStoreId,
				isBundle,
				limit,
				includeDefault
		  );
	if (offerResult.some) {
		return offerResult.some.offers.map(RetailerOffer.FromMercuryOffer);
	}
	return [];
};

// // eslint-disable-next-line max-len
export const fetchDefaultRetailerOffers = async (
	promotionId: string
): Promise<RetailerOffer[] | undefined> => {
	const limitp = getQueryStringParamValue('limit');
	const limit = parseInt(limitp, 10);
	const retailerName = MercuryRetailer.WALMART;
	// eslint-disable-next-line no-restricted-globals
	const offerResult: Option<GetOffersResponse> = isNaN(limit)
		? // eslint-disable-next-line max-len
		  await getDefaultOffers(promotionId)
		: // eslint-disable-next-line max-len
		  await getDefaultOffers(promotionId);
	if (offerResult.some) {
		return offerResult.some.offers.map(RetailerOffer.FromMercuryOffer);
	}
	return [];
};
